import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function ServiceOverviewSection() {
  return (
    <section id="overview" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={dxAdvisoryData.serviceOverview.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3 md:mb-4">
            {dxAdvisoryData.serviceOverview.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {dxAdvisoryData.serviceOverview.description}
          </p>
        </div>

        {/* Overview Table */}
        <div className="max-w-3xl mx-auto reveal">
          <div className="rounded-lg border border-background-200/70 overflow-hidden">
            {dxAdvisoryData.serviceOverview.items.map((item, idx) => (
              <div
                key={item.label}
                className={`grid grid-cols-[120px_1fr] md:grid-cols-[160px_1fr] ${
                  idx < dxAdvisoryData.serviceOverview.items.length - 1
                    ? "border-b border-background-200/70"
                    : ""
                } ${idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}`}
              >
                <div className="px-4 md:px-6 py-3.5 md:py-4 bg-background-100/80 flex items-center">
                  <span className="text-sm md:text-base font-bold text-foreground-800 font-label">
                    {item.label}
                  </span>
                </div>
                <div className="px-4 md:px-6 py-3.5 md:py-4 flex items-center">
                  <span className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}